import preloader from "../preloader";

function waitForButton(selector, callback) {
    const observer = new MutationObserver((_, obs) => {
        const button = document.querySelector(selector);
        if (button) {
            callback(button);
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

let isHelpCrunchInitialized = false;
let isBinotelInitialized = false;
let isHelpCrunchReady = false;

const initHelpCrunch = async () => {
    if (isHelpCrunchInitialized) return;
    if (window.innerWidth < 1284) {
      preloader(true);
    }
    isHelpCrunchInitialized = true;
    window.helpcrunchSettings = {
        organization: 'ukrzoloto',
        appId: 'e657d70c-edb0-4c4c-affa-fc51ba3dbc1a',
        showWidget: false
    };
    (function(w,d){var hS=w.helpcrunchSettings;if(!hS||!hS.organization){return;}var widgetSrc='https://'+hS.organization+'.widget.helpcrunch.com/';w.HelpCrunch=function(){w.HelpCrunch.q.push(arguments)};w.HelpCrunch.q=[];function r(){if (d.querySelector('script[src="' + widgetSrc + '"')) { return; }var s=d.createElement('script');s.async=1;s.type='text/javascript';s.src=widgetSrc;s.onload=()=>{w.HelpCrunch("onCustomerMessage", function (event) {w.dataLayer?.push({event: "sendChatMessage"})})};(d.body||d.head).appendChild(s);}if(d.readyState === 'complete'||hS.loadImmediately){r();} else if(w.attachEvent){w.attachEvent('onload',r)}else{w.addEventListener('load',r,false)}})(window, document);
    ensureChatVisibilitySync();
};

let helpCrunchReadyPromise = null;
const waitForHelpCrunchReady = () => {
    if (isHelpCrunchReady) return Promise.resolve();
    if (!helpCrunchReadyPromise) {
        helpCrunchReadyPromise = new Promise((resolve) => {
            window.HelpCrunch("onReady", () => {
                isHelpCrunchReady = true;
                preloader(false);
                resolve();
            });
        });
    }
    return helpCrunchReadyPromise;
};

const initBinotel = async () => {
    if (isBinotelInitialized) return;
    if (window.innerWidth >= 1284) {
        isBinotelInitialized = true;
        (function(d, w, s) {
            var widgetHash = 'ysvo35s9xutubacbrke2', gcw = d.createElement(s); gcw.type = 'text/javascript'; gcw.async = true;
            gcw.src = '//widgets.binotel.com/getcall/widgets/'+ widgetHash +'.js';
            var sn = d.getElementsByTagName(s)[0]; sn.parentNode.insertBefore(gcw, sn);
        })(document, window, 'script');
    }
};

const supportButtonIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="30" viewBox="0 0 36 30"><path fill="currentColor" fill-rule="evenodd" d="M28.202 13.052c.255-.793.39-1.622.39-2.478C28.592 4.652 22.135 0 14.296 0 6.456 0 0 4.652 0 10.574c0 3.148 1.846 6.031 4.935 8.005-.005.402-.005 4.041-.005 4.041 0 1.372 1.305 1.998 2.37 1.123 0 0 2.557-2.101 3.538-2.905a19.489 19.489 0 0 0 5.568.195c.771 3.35 4.653 5.798 9.228 5.798.234 0 .467-.007.698-.02.495.405 2.846 2.342 2.846 2.342 1.066.875 2.371.249 2.371-1.123 0 0 .01-2.29.01-2.77C33.696 23.956 35 21.986 35 19.808c0-3.273-2.902-5.932-6.798-6.757zm-2.005-.253c.276-.712.423-1.459.423-2.225 0-4.672-5.462-8.607-12.324-8.607-6.863 0-12.324 3.935-12.324 8.607 0 2.549 1.628 4.957 4.442 6.602l.487.285v4.08l3.042-2.517.365-.3.464.096a17.556 17.556 0 0 0 5.546.244c.494-3.592 4.525-6.277 9.316-6.277.189 0 .376.004.563.012zm-.563 12.064c-4.14 0-7.395-2.344-7.395-5.054 0-2.71 3.255-5.055 7.395-5.055s7.394 2.345 7.394 5.055c0 1.555-1.073 3.041-2.924 4.013l-.527.276v.594l.012 2.25-2.31-1.898-.311-.256-.402.035c-.307.027-.618.04-.932.04zm-3.45-4.207a.985.985 0 1 0-.987-.984c0 .543.442.984.986.984zm3.45 0a.985.985 0 1 0-.986-.984c0 .543.441.984.986.984zm-16.76-7.87a1.97 1.97 0 0 0 1.971-1.966 1.97 1.97 0 0 0-1.972-1.968 1.97 1.97 0 0 0-1.972 1.968 1.97 1.97 0 0 0 1.972 1.967zm5.915 0a1.97 1.97 0 0 0 1.972-1.966 1.97 1.97 0 0 0-1.972-1.968 1.97 1.97 0 0 0-1.972 1.968 1.97 1.97 0 0 0 1.972 1.967zm14.296 7.87a.985.985 0 1 0-.986-.984c0 .543.441.984.986.984zm-8.38-7.87a1.97 1.97 0 0 0 1.971-1.966 1.97 1.97 0 0 0-1.972-1.968 1.97 1.97 0 0 0-1.972 1.968 1.97 1.97 0 0 0 1.972 1.967z"></path></svg>`;
const closeIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2929 6.41L13.0564 11.6464L12.7029 12L13.0564 12.3536L18.2929 17.59L17.59 18.2929L12.3536 13.0564L12 12.7029L11.6464 13.0564L6.41 18.2929L5.70711 17.59L10.9436 12.3536L11.2971 12L10.9436 11.6464L5.70711 6.41L6.41 5.70711L11.6464 10.9436L12 11.2971L12.3536 10.9436L17.59 5.70711L18.2929 6.41Z" fill="white" stroke="white"></path></svg>`;

const updateButtonIcon = (button) => {
    button.innerHTML = button.classList.contains("support-button-active") ? closeIcon : supportButtonIcon;
};

let isChatVisibilitySyncAdded = false;

const ensureChatVisibilitySync = () => {
    if (isChatVisibilitySyncAdded) return;
    isChatVisibilitySyncAdded = true;
    const button = document.querySelector(".support-button");
    if (!button) return;
    window.HelpCrunch("onChatOpen", () => {
        button.style.display = "none";
    });
    window.HelpCrunch("onChatClose", () => {
        button.classList.remove("support-button-active");
        updateButtonIcon(button);
        button.style.display = "flex";
    });
};

export const openHelpCrunchChat = async () => {
    await initHelpCrunch();
    await waitForHelpCrunchReady();
    window.HelpCrunch("openChat");
    window.HelpCrunch("typeUserMessage", "");
};

export const initSupport = () => {
    if (window.isSupportChatEnabled === false) return;

    const createInitButton = () => {
        const initSupportButton = document.createElement("button");
        initSupportButton.innerHTML = supportButtonIcon;
        initSupportButton.classList.add("support-button");

        const currentLang = document.documentElement.getAttribute('lang');
        initSupportButton.setAttribute('aria-label', currentLang === 'en' ? 'Chat' : 'Чат');

        const updateIcon = () => updateButtonIcon(initSupportButton);

        const createHelpCrunchButton = (binotelButton) => {
            if (document.querySelector(".helpcrunch-button")) return;
            const button = document.createElement("button");
            button.innerHTML = supportButtonIcon;
            button.classList.add("helpcrunch-button");
            document.body.appendChild(button);

            binotelButton.addEventListener("click", function () {
                initSupportButton.classList.remove("support-button-active");
                binotelButton.style.display = "none";
                button.style.display = "none";
                updateIcon()
            })

            button.addEventListener("click", function () {
                button.style.display = "none";
                if (binotelButton) {
                    binotelButton.style.display = "none";
                }
                window.HelpCrunch("openChat");
                window.HelpCrunch("onChatClose", function () {
                    initSupportButton.classList.remove("support-button-active");
                    updateIcon();
                })
            })
        }

        initSupportButton.addEventListener("click", async function () {
            initSupportButton.classList.toggle('support-button-active');
            updateIcon();
            const helpCrunchButton = document.querySelector(".helpcrunch-button");
            const binotelButton = document.querySelector("#bingc-phone-button");
            await initHelpCrunch();
            if (window.innerWidth >= 1284) {
                initBinotel();
                waitForButton('#bingc-phone-button', createHelpCrunchButton);
            } else {
                if (!isHelpCrunchReady) {
                  window.HelpCrunch("onReady", () => {
                    isHelpCrunchReady = true;
                    preloader(false);
                  });
                }
                window.HelpCrunch("openChat");
            }
            if (helpCrunchButton) {
                helpCrunchButton.style.display = helpCrunchButton.style.display === "none" ? "block" : "none";
            }
            if (binotelButton) {
                binotelButton.style.display = binotelButton.style.display === "none" ? "block" : "none";
            }

        })
        document.body.appendChild(initSupportButton);
    }

    createInitButton();
};